import React from "react";
import {forms} from "../forms";
import {StepProps} from "../step-props";
import {ErrorMessageDialog} from "../../../components/dialogs/ErrorMessageDialog";
import {ScenarioHeader} from "../../../components/Scenario/Header";
import {useTariffication} from "./hooks/useTariffication";
import {MtplPackageSelectFormSmartDrive} from "../forms/PackageSelect/MtplPackageSelectFormSmartDrive";
import {useErrorDialog} from "../../../utils/hooks/useErrorDialog";
import {MtplScenarioHeader} from "../forms/MtplScenarioHeader";

export const MtplTarifficationStepSmartDrive = ({step}: StepProps) => {
    const {
        textErrorMessageDialog, setTextErrorMessageDialog,
        openErrorMessageDialog, setOpenErrorMessageDialog,
        errorDialogType, setErrorDialogType,
        textDetailErrorMessageDialog, setTextDetailErrorMessageDialog,
        onClose, setOnClose
    } = useErrorDialog();

    const {
        tariffied,
        packages,
        onPackageSelect,
        onRecalculate,
        onFormSubmit
    } = useTariffication("mtpl_online_00001_smart_drive", setTextErrorMessageDialog, setTextDetailErrorMessageDialog, setOpenErrorMessageDialog);

    return (
        <>
            <MtplScenarioHeader/>

            {tariffied && (
                <MtplPackageSelectFormSmartDrive packages={packages}
                                                 onPackageSelect={onPackageSelect}
                                                 onBackStep={onRecalculate}/>
            )}

            {!tariffied && (
                step.forms.map(form => {
                    return React.createElement(forms[form.code], {
                        key: form.code,
                        onFormSubmit,
                        setTextErrorMessageDialog,
                        setOpenErrorMessageDialog,
                        setErrorDialogType,
                        setOnClose
                    })
                })
            )}

            <ErrorMessageDialog type={errorDialogType}
                                text={textErrorMessageDialog}
                                open={openErrorMessageDialog}
                                onClickListener={onClose}
                                textDetail={textDetailErrorMessageDialog}/>
        </>
    );
};